module.exports = __webpack_public_path__ + "img/organo-cerimonia.22ff8500.jpg";